interface IUtilsStoreState {
  sidebarOpen: boolean
}

export const useUtilsStore = defineStore('utils', {
  state: (): IUtilsStoreState => ({
    sidebarOpen: false,
  }),

  getters: {
    getSidebarOpen(state) {
      return state.sidebarOpen
    },

  },

  actions: {
    toggleSidebarOpen() {
      this.sidebarOpen = !this.sidebarOpen
    },
  },

})
